export default "__VITE_ASSET__D96jEUf4__"